module.exports = __webpack_public_path__ + "img/about_3.1a8f599d.jpg";